<template>
    <div class="fill-height d-flex flex-column">

        <div id="nd-title" class="d-flex flex-column align-center pt-4 pb-2">
            <v-icon size="x-large" color="red-darken-2">mdi-sack</v-icon>
            <p style="color: lightgrey">Dati raccolti</p>
            <v-divider />
        </div>
        <!-- <v-btn  icon="mdi-cog" size="small" class="ma-3" color="blue-grey-darken-4" 
            v-if="runtimeStore.session.settings.showLocalSettingsBtn"/> -->
        <v-spacer />

        <div id="nd-container">

            <!-- 'default' | 'accordion' | 'inset' | 'popout' -->

            <template v-if="today">

                <v-card style="border-top: 1px solid #ffffff33">
                    <v-card-title class="d-flex flex-row justify-space-between align-center"
                        @click="todayLayerClicked()">
                        <div>
                            <v-icon class="pl-3 mr-3" color="lime">mdi-calendar-today</v-icon>
                            {{ layerTitle(today) }}
                        </div>
                        <span class="countLayerFeatures">
                            ({{ countLayerFeatures(today) }}) &nbsp;
                        </span>
                    </v-card-title>


                    <div class="pl-4 pb-4 d-flex flex-row justify-end  ">


                        <span v-if="ENVIRONMENT === 'development'" class="bg-red-darken-4 px-2">

                            <v-dialog width="auto" style="max-height: 90vh">
                                <template v-slot:activator="{ props }">
                                    <v-fab v-bind="props" color="red-darken-3" class="mr-2" size="x-small"
                                        icon="mdi-broom">
                                    </v-fab>
                                </template>

                                <template v-slot:default="{ isActive }">
                                    <v-card theme="dark">
                                        <v-card-item class="position-sticky bg-grey-darken-4 top-0"
                                            style='z-index:20001;'>
                                            <v-card-title>Svuota</v-card-title>
                                        </v-card-item>
                                        <v-card-text>Elimina i dati odierni
                                        </v-card-text>

                                        <v-card-actions
                                            class="d-flex align-center position-sticky bg-grey-darken-4 bottom-0"
                                            style='z-index:20001;'>
                                            <v-btn variant="flat" size="large" color="red" class="my-1 mx-0"
                                                @click="emptyDayNode(today); isActive.value = false">
                                                <v-icon>mdi-broom</v-icon>
                                                Svuota</v-btn>
                                            <v-btn variant="outlined" size="large" color="white" class="my-1 mx-0"
                                                @click="isActive.value = false;">
                                                <v-icon>mdi-chevron-down</v-icon>
                                                Indietro</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>

                            <v-dialog width="auto" style="max-height: 90vh">
                                <template v-slot:activator="{ props }">
                                    <v-fab v-bind="props" color="yellow-darken-4" class="" size="x-small"
                                        icon="mdi-arrow-right-bold">
                                    </v-fab>
                                </template>

                                <template v-slot:default="{ isActive }">
                                    <v-card theme="dark">
                                        <v-card-item class="position-sticky bg-grey-darken-4 top-0"
                                            style='z-index:20001;'>
                                            <v-card-title>Muovi alla data</v-card-title>
                                        </v-card-item>
                                        <v-card-text>Muovi i dati odierni alla data selezionata
                                            <v-text-field v-model="newTodayDate" label="Data" type="date"
                                                class="mt-3"></v-text-field>
                                        </v-card-text>

                                        <v-card-actions
                                            class="d-flex align-center position-sticky bg-grey-darken-4 bottom-0"
                                            style='z-index:20001;'>
                                            <v-btn variant="flat" size="large" color="yellow-darken-4" class="my-1 mx-0"
                                                @click="moveTodayToDate(); isActive.value = false">
                                                <v-icon class="mr-2">mdi-arrow-right-bold</v-icon>
                                                Muovi</v-btn>
                                            <v-btn variant="outlined" size="large" color="white" class="my-1 mx-0"
                                                @click="isActive.value = false;">
                                                <v-icon class="mr-2">mdi-chevron-down</v-icon>
                                                Indietro</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>

                        </span>

                        <v-spacer />

                        <v-dialog width="auto" style="max-height: 90vh">
                            <template v-slot:activator="{ props }">
                                <v-fab v-bind="props" color="blue-darken-3" class="mr-5" size="x-small"
                                    icon="mdi-format-list-bulleted">
                                </v-fab>
                            </template>

                            <template v-slot:default="{ isActive }">
                                <v-card theme="dark">
                                    <v-card-item class="position-sticky bg-black top-0" style='z-index:20001;'>
                                        <v-card-title>{{ layerTitle(today) }}</v-card-title>
                                    </v-card-item>
                                    <v-card-text>

                                        <v-list density="compact" style="overflow-y: auto" class="d-flex flex-column ">
                                            <v-list-item v-for="(feature, i) in trackerDaysLayers[today].features"
                                                :key="i">
                                                <template v-slot:prepend>
                                                    <v-chip color="white" class="mr-2" size="x-small">
                                                        {{ i + 1 }}
                                                    </v-chip>
                                                </template>
                                                <v-btn v-if="feature?.geometry?.coordinates" class="mr-2"
                                                    :color="segnalazioneColor(feature)" size="small"
                                                    @click="goToFeature(feature.properties.uuid); isActive.value = false">
                                                    <v-icon class="mr-2">mdi-map-search</v-icon>
                                                    {{ feature.properties?.model }}
                                                </v-btn>

                                            </v-list-item>
                                        </v-list>


                                    </v-card-text>

                                    <v-card-actions
                                        class="d-flex flex-column align-center position-sticky bg-black bottom-0"
                                        style='z-index:20001;'>
                                        <v-btn variant="outlined" size="large" color="white" class="my-1 mx-0"
                                            @click="isActive.value = false;">
                                            <v-icon>mdi-chevron-down</v-icon>
                                            Indietro</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </template>
                        </v-dialog>


                    </div>

                </v-card>
            </template>
            <v-expansion-panels variant="accordion" flat>

                <v-expansion-panel 
                    :readonly="orderedDaysArchive.length == 0" style="border-top: 1px solid #ffffff33">
                    <v-expansion-panel-title
                    :expand-icon="orderedDaysArchive.length == 0 ? '' : 'mdi-chevron-down'">
                    <v-icon 
                        class="mr-2" 
                        color="blue-grey">mdi-calendar-multiselect</v-icon>
                        <span>
                            Archivio giornate ({{ orderedDaysArchive.length }})
                        </span>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="pa-0">

                        <v-list density="compact" nav style="overflow-y: auto">

                            <template v-for="(day, i) in orderedDaysArchive" :key="i">
                                <v-list-item fluid :style="{ 'background': i % 2 == 0 ? '#ffffff11' : '' }">
                                    <!-- <v-icon v-if="trackerDaysLayers[day].visible"
                                                        @click="layerToggled(trackerDaysLayers[day])"
                                                        color="blue-lighten-2">mdi-eye</v-icon>
                                                    <v-icon color="grey-darken-1" v-else>mdi-eye-off</v-icon> -->
                                    <v-switch inset v-model="trackerDaysLayers[day].visible" color="primary"
                                        class="mr-2" @click="layerToggled(trackerDaysLayers[day])" hide-details
                                        density="compact">
                                        <template v-slot:label>
                                            {{ layerTitle(day) }}
                                            <span class="countLayerFeatures">
                                                ({{ countLayerFeatures(day) }})
                                                <template v-if="isDaySynced(day)">
                                                    <v-icon class="ml-3"
                                                        color="green-lighten-2">mdi-cloud-check</v-icon>
                                                </template>
                                                <template v-else>
                                                    <v-icon class="ml-3" color="grey">mdi-cloud-off</v-icon>
                                                </template>
                                            </span>
                                        </template>
                                    </v-switch>

                                    <template v-if="trackerDaysLayers[day].visible">

                                        <div class="pl-4 py-4 d-flex flex-row justify-end  ">


                                            <span v-if="ENVIRONMENT === 'development'"
                                                class="bg-red-darken-4 px-2 mr-2">


                                                <v-dialog width="auto" style="max-height: 90vh">
                                                    <template v-slot:activator="{ props }">
                                                        <v-fab v-bind="props" color="red-darken-3" class="mr-2"
                                                            size="x-small" icon="mdi-broom">
                                                        </v-fab>
                                                    </template>

                                                    <template v-slot:default="{ isActive }">
                                                        <v-card theme="dark">
                                                            <v-card-item class="position-sticky bg-grey-darken-4 top-0"
                                                                style='z-index:20001;'>
                                                                <v-card-title>Svuota</v-card-title>
                                                            </v-card-item>
                                                            <v-card-text>Elimina i dati del {{ day }}
                                                            </v-card-text>

                                                            <v-card-actions
                                                                class="d-flex align-center position-sticky bg-grey-darken-4 bottom-0"
                                                                style='z-index:20001;'>
                                                                <v-btn variant="flat" size="large" color="red"
                                                                    class="my-1 mx-0"
                                                                    @click="emptyDayNode(day); isActive.value = false">
                                                                    <v-icon>mdi-broom</v-icon>
                                                                    Elimina</v-btn>
                                                                <v-btn variant="outlined" size="large" color="white"
                                                                    class="my-1 mx-0" @click="isActive.value = false;">
                                                                    <v-icon>mdi-chevron-down</v-icon>
                                                                    Indietro</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </template>
                                                </v-dialog>

                                                <v-fab @click="trackerDaysLayers[day].state = null" color="primary"
                                                    class="" size="x-small" icon="mdi-cloud-off">
                                                </v-fab>
                                            </span>

                                            <v-dialog width="auto" style="max-height: 90vh">
                                                <template v-slot:activator="{ props }">
                                                    <v-fab v-bind="props" color="blue-darken-3" class="mr-3"
                                                        size="x-small" icon="mdi-format-list-bulleted">
                                                    </v-fab>
                                                </template>

                                                <template v-slot:default="{ isActive }">
                                                    <v-card theme="dark">
                                                        <v-card-item class="position-sticky bg-black top-0"
                                                            style='z-index:20001;'>
                                                            <v-card-title>{{ layerTitle(day) }}</v-card-title>
                                                        </v-card-item>
                                                        <v-card-text>

                                                            <v-list density="compact" style="overflow-y: auto"
                                                                class="d-flex flex-column ">
                                                                <v-list-item
                                                                    v-for="(feature, i) in trackerDaysLayers[day].features"
                                                                    :key="i">
                                                                    <template v-slot:prepend>
                                                                        <v-chip color="white" class="mr-2"
                                                                            size="x-small">
                                                                            {{ i + 1 }}
                                                                        </v-chip>
                                                                    </template>
                                                                    <v-btn v-if="feature?.geometry?.coordinates"
                                                                        class="mr-2" :color="segnalazioneColor(feature)"
                                                                        size="small"
                                                                        @click="goToFeature(feature.properties.uuid); isActive.value = false">
                                                                        <v-icon class="mr-2">mdi-map-search</v-icon>
                                                                        {{ feature.properties?.model }}
                                                                    </v-btn>

                                                                    <template v-slot:append>
                                                                        <v-chip color="white" class="mr-2"
                                                                            size="x-small">
                                                                            {{ feature.properties?.state || "-" }}
                                                                        </v-chip>
                                                                    </template>
                                                                </v-list-item>
                                                            </v-list>


                                                        </v-card-text>

                                                        <v-card-actions
                                                            class="d-flex flex-column align-center position-sticky bg-black bottom-0"
                                                            style='z-index:20001;'>
                                                            <v-btn variant="outlined" size="large" color="white"
                                                                class="my-1 mx-0" @click="isActive.value = false;">
                                                                <v-icon>mdi-chevron-down</v-icon>
                                                                Indietro</v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </template>
                                            </v-dialog>

                                        </div>
                                    </template>

                                    <!-- <template v-slot:append v-if="trackerDaysLayers[day].visible">

                                        <v-btn size="" v-bind="props" color="primary">
                                            <template v-slot:prepend>
                                                <v-icon size="small" class="ma-1">mdi-menu</v-icon>
                                            </template>
                                        </v-btn>

                                    </template> -->
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel v-if="phytosociologicalLayer?.features"
                    :readonly="phytosociologicalLayer.features.length == 0" style="border-top: 1px solid #ffffff33">
                    <v-expansion-panel-title
                    :expand-icon="phytosociologicalLayer.features.length == 0 ? '' : 'mdi-chevron-down'">
                    <v-icon class="mr-2" color="#E65100">mdi-chart-bubble</v-icon>
                        <span>
                            Fitosociologia ({{ phytosociologicalLayer.features.length }})
                        </span>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="pa-0">

                        <v-list density="compact" nav style="overflow-y: auto">
                            <v-list-item>
                                <v-switch inset v-model="phytosociologicalLayer.visible" color="primary" class="mr-2"
                                    @click="layerToggled(phytosociologicalLayer)" hide-details density="compact"
                                    label="Fitosociologia" />

                                <!-- <v-icon v-if="phytosociologicalLayer.visible"
                                        color="blue-lighten-2">mdi-eye</v-icon>
                                    <v-icon color="grey-darken-1" v-else>mdi-eye-off</v-icon> -->
                            </v-list-item>


                            <v-list-item
                                v-show="phytosociologicalLayer.visible && phytosociologicalLayer?.features?.length > 0">

                                <!-- <span class="ml-5">Azioni</span> -->

                                <p class="ml-5">

                                    <v-dialog width="auto">
                                        <template v-slot:activator="{ props }">
                                            <v-btn size="small" v-bind="props" color="red-darken-3" class="mt-2">
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-delete</v-icon>
                                                </template>elimina tutti</v-btn>
                                        </template>

                                        <template v-slot:default="{ isActive }">
                                            <v-card theme="dark">
                                                <v-card-item>
                                                    <v-card-title>Eliminazione</v-card-title>
                                                    <v-card-subtitle>Stai per eliminare tutti gli
                                                        oggetti</v-card-subtitle>
                                                </v-card-item>
                                                <v-card-text>
                                                    <p class="mb-2">
                                                        Sei sicuro di voler eliminare<br>
                                                        <strong>tutti</strong> i rilievi fitosociologici raccolti?
                                                        <v-switch inset v-model="deleteAllPhytoConfirm" label="Sicuro"
                                                            color="red" class="my-2"></v-switch>
                                                    </p>
                                                </v-card-text>

                                                <v-card-actions class="d-flex flex-column align-center ">
                                                    <v-btn variant="flat" size="large" color="red-darken-2"
                                                        :disabled="!deleteAllPhytoConfirm" class="my-1"
                                                        @click="localDeleteAllPhyto(); isActive.value = false; deleteAllPhytoConfirm = false;">
                                                        <v-icon>mdi-delete</v-icon>
                                                        Elimina</v-btn>
                                                    <v-btn variant="outlined" size="large" color="white"
                                                        class="my-1 mx-0"
                                                        @click="isActive.value = false; deleteAllPhytoConfirm = false">
                                                        <v-icon>mdi-chevron-down</v-icon>
                                                        Indietro</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </template>
                                    </v-dialog>

                                    <v-btn size="small" @click="downloadAll" color="primary" class="mt-2">
                                        <template v-slot:prepend>
                                            <v-icon>mdi-download</v-icon>
                                        </template>scarica tutti</v-btn>

                                </p>
                            </v-list-item>


                        </v-list>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>

        </div>
    </div>
</template>



<script setup>




import { onMounted, ref } from 'vue';
import { computed } from 'vue'
import { useDataStore } from "@/store/data";


import { json2csv } from 'json-2-csv';

const dataStore = useDataStore();
import { useToastsStore } from "@/store/toasts";
const toastsStore = useToastsStore();

const deleteAllPhytoConfirm = ref(false)

const trackerDaysLayers = defineModel("trackerDaysLayers")

const phytosociologicalLayer = defineModel("phytosociologicalLayer")

const emit = defineEmits(["zoomToLayer", "zoomToFeature"])


const orderedDays = computed(() => {
    // console.log(trackerDaysLayers.value)
    const ks = Object.keys(trackerDaysLayers.value)
    const days = ks

    return days.sort((a, b) => {
        // console.log(new Date(a).getTime())
        return new Date(b).getTime() - new Date(a).getTime()
    })
})



const segnalazioneColor = (feature) => {
    // console.log(feature)
    const color = dataStore.ventaglio_possibili.find(v => v.modelCamel === feature?.properties?.model)?.color
    if (color)
        return color
    return "grey"
}

const orderedDaysArchive = computed(() => {
    return orderedDays.value.filter(day => !isDayToday(day))
})

const today = computed(() => {
    return orderedDays.value.filter(day => isDayToday(day)).find(() => true)
})


const emptyDayNode = async (dayname) => {

    dataStore.userData.tracker.days[dayname].features = []

    if (!isDayToday(dayname)) {
        delete dataStore.userData.tracker.days[dayname]
    }

    dataStore.save()
    toastsStore.toast({
        title: `Rimozione dati ${dayname}`,
        text: `Rimossi rilievi odierni`,
        type: "info",
    })
}



const isDaySynced = (day) => {
    // console.log(day)
    const dataday = dataStore.userData.tracker.days?.[day]
    return dataStore.isLayerSynced(dataday)
}


const countLayerFeatures = function (day) {
    // console.log(day)
    // console.log(trackerDaysLayers.value[day])
    return trackerDaysLayers.value[day].features.length
}
const layerTitle = function (day) {
    // console.log(day)
    // console.log(trackerDaysLayers.value[day])

    return new Date(day).toLocaleDateString(undefined, { // you can use undefined as first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }) // + " (" + countLayerFeatures(day) + ")"
}

const isDayToday = function (day) {
    const today = new Date()
    const d = new Date(day)
    return today.toDateString() === d.toDateString()
}

const layerToggled = async (layer) => {



    setTimeout(() => {
        if (layer.visible)
            emit('zoomToLayer', layer)
    }, 100)

}



const goToFeature = (uuid) => {
    console.log(uuid)
    emit('zoomToFeature', uuid)
}


const todayLayerClicked = () => {
    emit('zoomToLayer', trackerDaysLayers.value[today.value])
    // console.log(trackerDaysLayers.value[today.value])
    // console.log("todayLayerClicked")
}

const togglePhytoLayer = (layer) => {
    layer.visible = !layer.visible
    // console.log(layer)
}

const localDeleteAllPhyto = (layer) => {
    const howMany = dataStore.deleteAllPhytosociological()
    toastsStore.toast({
        title: `Fitosociologia`,
        text: `Rimossi ${howMany} rilievi.`,
        type: "info",
    })
}

const downloadAll = async () => {
    let csv = ""


    let all_taxa_data = []


    for (const feature of phytosociologicalLayer.value.features) {

        if (!feature?.properties?.taxa)
            continue

        const complete_data = JSON.parse(JSON.stringify(feature.properties, null, 2))

        complete_data.altri_autori = complete_data.altri_autori.join(",")

        delete complete_data.taxa

        const taxa_data = JSON.parse(JSON.stringify(feature.properties.taxa, null, 2))
        const segnalazioni_data = []

        for (const taxon of taxa_data) {
            const newSegnalazione = {}
            for (const [key, value] of Object.entries(taxon)) {
                newSegnalazione["segnalazione__" + key] = value
            }
            segnalazioni_data.push(newSegnalazione)
        }

        for (const segnalazione of segnalazioni_data) {
            Object.assign(segnalazione, complete_data)
            all_taxa_data.push(segnalazione)
        }


    }

    csv = await json2csv(all_taxa_data)


    console.log(csv)


    console.log("migliorare il download e attivarlo")
    return


    // const data = btoa(csv)
    // const downloadLink = document.createElement("a")

    // const now = new Date().toISOString().replace(/:/g, "-")

    // const filename = `data-all-phytosociological${now}.csv`
    // downloadLink.download = filename
    // downloadLink.innerHTML = "download feature data"
    // downloadLink.href = "data:text/json;base64," + data
    // downloadLink.click()
    // downloadLink.remove()
}




const newTodayDate = ref(null)

const moveTodayToDate = async () => {
    const newDate = newTodayDate.value
    if (!newDate) {
        toastsStore.toast({
            title: `Data non valida`,
            text: `Inserisci una data valida`,
            type: "error",
        })
        return
    }

    if (newDate === today.value) {
        toastsStore.toast({
            title: `Data non valida`,
            text: `La data di destinazione è la stessa di quella di partenza`,
            type: "error",
        })
        return
    }

    if (orderedDays.value.includes(newDate)) {
        toastsStore.toast({
            title: `Data non valida`,
            text: `La data di destinazione è già presente`,
            type: "error",
        })
        return
    }


    dataStore.userData.tracker.days[newDate] = dataStore.userData.tracker.days[today.value]
    delete dataStore.userData.tracker.days[today.value]
    dataStore.save()

    toastsStore.toast({
        title: `Spostamento dati`,
        text: `Dati odierni spostati alla data ${newDate}`,
        type: "info",
    })
    newTodayDate.value = null
}




onMounted(() => {
    // console.log(orderedDays.value)
})


</script>
<style scoped>
#nd-title {
    /* navigation drawer sticky title */
    position: sticky;
    top: 0;
    z-index: 100;
    background: #212121;
    /* opacity: .4; */
}

.v-expansion-panel-text {
    max-height: 50vh;
    overflow: auto;
}

.countLayerFeatures {
    font-size: .8em;
    margin-left: 8px;
}


:deep(.v-expansion-panel-text__wrapper) {
    padding: 0;
}
</style>
